<template>
    <div>

            <div class="card card-body" ref="print">
                <div><center>StepUp Academy</center></div>
                <div><center>113 Apex Atrium Motor City, Dubai, UAE</center></div>
                <div class="mt-2">
                    <div><center>04 453 4360</center></div>
                    <div><center>info@stepup.ae</center></div>
                    <div><center>https://stepup.ae</center></div>
                </div>
                <div class="mt-2">
                    <div><center>TRN: 1002540945100003</center></div>
                </div>
                <div class="mt-2">
                    <div><center>Tax Invoice</center></div>
                </div>
                <div class="mt-2">
                    <div v-for="invoice in invoices" v-bind:key="invoice.id"><center>Invoice #: STEP-{{invoice.id + 1}}</center></div>
                </div>
                <hr>
                    <div><center>Served By: {{staff}}</center></div>
                    <div><center>Date Purchased: {{ myDate }} </center></div>
                    <div v-if="location"><center>Location: {{ location.name }} </center></div>
                <hr>
                <table class="table table-bordered table-responsive">
                    <thead>
                        <tr>
                            <th width='70%' class="text-center">Product</th>
                            <th width='8%' class="text-center">Rate Incl Vat</th>
                            <th width='8%' class="text-center">QTY</th>
                            <th width='8%' class="text-center">Vat</th>
                            <th width='8%' class="text-center">Disc</th>
                            <th width='8%' class="text-center">Total Incl Vat</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(cart, index) in carts" v-bind:key="index">
                            <td class="text-center"><strong>{{cart.product}}</strong>
                                <div><small>{{cart.option}}</small></div>

                                <div v-if="cart.notes !== ''">({{cart.notes}})</div>
                            </td>
                            <td class="text-center"><center>{{cart.price}}</center></td>
                            <td class="text-center"><center>{{cart.quantity}}</center></td>
                            <td class="text-center"><center> {{ parseFloat(vatTotal(cart)).toFixed(2) }}
                                <!-- {{ parseFloat(cart.vat).toFixed(2) }} -->
                                </center></td>
                            <td class="text-center"><center>{{ parseFloat(cart.discount).toFixed(2) }}</center></td>
                            <td class="text-center"><center> {{ parseFloat(itemTotal(cart)).toFixed(2) }}
                                <!-- {{ parseFloat(cart.total).toFixed(2) }} -->
                                </center></td>
                        </tr>
                    </tbody>
                </table>

                <div class="mt-2 text-right">
                    <hr>
                    <p>Taxable Value: {{ parseFloat(taxable).toFixed(2) }} AED</p>
                    <p v-if="discount !== 0.00">Total Discount: {{ parseFloat(discount).toFixed(2) }} AED</p>
                    <p>Vat 5%: {{ parseFloat(vat).toFixed(2) }} AED</p>
                    <p>Total Incl Vat: {{ parseFloat(totalprice).toFixed(2) }} AED</p>
                    <p>Payment: {{ totalpayment }} AED</p>
                    <p v-if="change > 0">Change: {{ change }} AED</p>
                    <p v-for="paym in payments" :key="paym.value">Paid: {{ paym.text }} </p>
                </div>
                <div style="page-break-after: always"></div>
                <!-- <hr style="border-top: dotted 1px;"> -->
            </div>

        <div class="col-md-12 mt-2 row" v-for="paym in payments" :key="paym.value">
            <div class="col-md-2">
                <sub class="text-danger">5th</sub>
                <label class="text-left"> Payment {{paym.text}} </label>
            </div>
            <div class="col-md-10">
                <input type="number" v-model="paym.halaga" class="form-control" />
            </div>
        </div>
        <div class="col-md-12  mt-2 row">
            <div class="col-md-2">
                <sub class="text-danger">6th</sub>
                <label> Notes </label>
            </div>
            <div class="col-md-10">
                <textarea v-model="notes" class="form-control" placeholder="notes"></textarea>
            </div>
        </div>

        <div class="col-md-12  mt-2 row" v-if="notes !== '' && change >= 0">
            <div class="col-md-2">
                <sub class="text-danger">7th</sub>
            </div>
            <div class="col-md-10">
                <button class="btn btn-success mt-2" @click="print"><i class="fa fa-shopping-cart"></i></button>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: ['carts', 'tax_vat', 'tax_vat_one', 'payments', 'location', 'term'],

    data() {
        return {
            invoices: [],
            customer:[],
            student:[],
            POSType:[],
            Settings:[],
            Walkin: this.$parent.$parent.walkin,
            user: '',
            // payment: 0,
            notes:'',
            staff: this.$root.staffname,
            copies: 2,
            myDate: new Date().toISOString().slice(0),


        }
    },
    created() {
      this.getRequirements()
    //   this.getPayment()
    },
    methods: {
        getRequirements() {
            axios
            .get('./api/POS/lastInvoice')
            .then((result) => {
                this.invoices = result.data
                console.log(this.invoices)

            }).catch((err) => {
                console.log(err)
            });
        },
        itemTotal(item){
                    return (item.quantity * item.price) - item.discount
        },
        vatTotal(item){
                return (((item.quantity * item.price) - item.discount) / this.tax_vat_one) * this.tax_vat
        },
        // getPayment(){
        //         this.payment = this.totalprice
        // },
        print(){

            this.POSType = this.$parent.$parent.POSType
            this.customer = this.$parent.$parent.customerDetails
            this.student = this.$parent.$parent.customerStudent
            this.user = this.$parent.$parent.user
            this.Settings = this.$parent.settings
            this.Walkin = this.$parent.$parent.walkin

            axios
            .post('./api/POS/Checkout', {
                users: this.user,
                products: this.carts,
                discount: this.discount,
                price: this.totalprice,
                taxable: this.taxable,
                vat: this.vat,
                paymentmethod: this.payments,
                payment: this.payment,
                notes: this.notes,
                customer: this.customer,
                student: this.student,
                POSType: this.POSType,
                Settings: this.Settings,
                Walkin: this.Walkin,
                change: this.change,
                location_id: this.location ? this.location.id : 0,
                user_id: this.$root.id,
                name: this.$root.staffname,
                date_range_id: this.term ? this.term.drid : null
            })
            .then((result) => {
                if (result.status === 200){
                    var printing = this.$refs.print.outerHTML

                    window.document.write(printing.repeat(3))
                    window.close()
                    window.print()

                    localStorage.removeItem(this.POSType.CartName)
                    localStorage.removeItem('customer')
                    localStorage.removeItem('student')
                    localStorage.removeItem('payment')
                    window.location.assign(this.POSType.URL);
                }else{
                    alert("Failed to create invoice. Please try again")
                }

            }).catch((err) => {
                alert("Failed to create invoice. Please try again")
                console.log(err)
            });


        }
    },
    computed: {
        totalprice() {
            return this.carts.reduce((total, item) => {
                return total + (item.quantity * item.price) - item.discount
            }, 0)
        },
        taxable : function() {
                return this.totalprice / this.tax_vat_one
        },
        vat : function () {
                return this.taxable * this.tax_vat
        },
        discount() {
            return this.carts.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
        totalpayment() {
            return this.payments.reduce((total, item) => {
                return total + Number(item.halaga)
            }, 0)
        },

        change(){
          let total = this.carts.reduce((total, item) => {
                return total + (item.quantity * item.price) - item.discount
            }, 0)

            return this.totalpayment - total
        }


    }

}
</script>
<style scoped>
@media print {
  div .cut {page-break-after: always;}
}
</style>




// WEBPACK FOOTER //
// resources/js/POS/Checkout.vue